import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import StorefrontHeader from "../components/header/StorefrontHeader";
import { Drawer } from "@mui/material";
import Cart from "../components/cart/Cart";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import GenieSpinner from "../../../components/core/genie-spinner/GenieSpinner";
import useUser from "../../../queries/routes/useUser";
import { useAuth0 } from "@auth0/auth0-react";
import { Get } from "../../../queries/utils/api";
import * as FullStory from "@fullstory/browser";

function Storefront() {
  const [open, setCartState] = React.useState(false);
  const { org_id } = useParams<{ org_id: string }>();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();

  const { data: user } = useUser();

  useEffect(() => {
    if (user) {
      FullStory.identify(user.id, { email: user.email });
    }
  }, [user]);

  useEffect(() => {
    // Check if user has a pending invite for this organization
    const checkPendingInvite = async () => {
      if (user && org_id) {
        try {
          const accessToken = await getAccessTokenSilently();
          const pendingInvite = await Get<{ id: string }>(
            `/api/invite/purchaser/pending/${org_id}`,
            accessToken
          );

          if (pendingInvite && pendingInvite.id) {
            // Redirect to accept invite page
            navigate(`/invite/${pendingInvite.id}`);
            return;
          }
        } catch (error) {
          // No pending invite found or error occurred, continue normally
          console.log("No pending invite found or error checking invite");
        }
      }
    };

    checkPendingInvite();
  }, [user, org_id, getAccessTokenSilently, navigate]);

  const toggleDrawer = (open: any) => (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setCartState(open);
  };

  // Redirect new users (without organizations) to onboarding
  useEffect(() => {
    if (user && (!user.organizations || user.organizations.length === 0)) {
      navigate("/details");
      return;
    }
  }, [user, navigate]);

  console.log("user", user);
  if (
    !user ||
    !user.organizations ||
    !user.purchasing_organizations ||
    user.organizations.length === 0 ||
    user.purchasing_organizations.length === 0
  ) {
    return <GenieSpinner />;
  }

  return (
    <Box>
      <Drawer anchor={"right"} open={open} onClose={toggleDrawer(false)}>
        <Cart closeDrawer={() => setCartState(false)} />
      </Drawer>
      <StorefrontHeader openDrawer={() => setCartState(true)} />
      <Outlet />
    </Box>
  );
}

export default withAuthenticationRequired(Storefront, {
  onRedirecting: () => <GenieSpinner />,
});
